import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import { RpmOidc, initUserManager } from 'rug-widgets';

import { history, configureStore } from './shared/store/configureStore';

import App from './App';

import CacheBuster from './CacheBuster';

import * as constants from './shared/constants/constants';
import * as serviceWorker from './serviceWorker';

import 'react-toastify/dist/ReactToastify.css';
import 'semantic-ui-css/semantic.min.css';
import './index.module.scss';

initUserManager(constants.AUTH_CONFIG);

const store = configureStore();

const rootElement = document.getElementById('root');
ReactDOM.render(
  <Provider store={store}>
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion)
          refreshCacheAndReload();
        return isLatestVersion && (
          <RpmOidc store={store} history={history}
            redirectPath='/callback'
            callbackPageContent={<div>Redirecting...</div>}>
            <App />
          </RpmOidc>)
      }}
    </CacheBuster>
  </Provider>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
